import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotifierService } from '../services/notifier.service';

/** User IDs permitted to access dev/components */
const DEV_ACCESS_USER_IDS: ReadonlySet<number> = new Set([
  1,    // Justin Erswell
  2,    // Tudor Bostan
  1230, // Tom Mayer
  924,  // Andy McDonald
  1709, // Claudiu Bekk
  1710, // Dr. Silviu Marc
  232,  // Melanie Richter
]);

@Injectable({
  providedIn: 'root'
})
export class DevAccessGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private notifierService: NotifierService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.userObject;

    if (user && DEV_ACCESS_USER_IDS.has(user.id)) {
      return true;
    }

    this.notifierService.notify('warning', 'You are not authorized to access this section.');
    this.router.navigate(['/projects']);
    return false;
  }
}
